import _debug from 'debug'

export default _debug('app')



// WEBPACK FOOTER //
// ./src/lib/debug.js